/** Admin console shell + Requests, Calendar review and System tabs (ALP-85). Existing sections keep the `admin` namespace. */
export const adminConsole = {
  product: "Malfak Admin",
  staffOnly: "Staff only",
  env: "Environment {{env}}",
  backToApp: "Back to app",
  signedInAs: "Signed in as",
  signOut: "Sign out",
  switchLang: "العربية",
  theme: "Theme",
  themeLight: "Light",
  themeDark: "Dark",
  themeSystem: "System",
  menu: "Account menu",
  tabs: {
    label: "Admin sections",
    overview: "Overview",
    requests: "Requests",
    users: "Users",
    orgs: "Orgs",
    plans: "Plans",
    ai: "AI models",
    aiActivity: "AI activity",
    flows: "Flows",
    audit: "Audit",
    calendar: "Calendar review",
    settings: "Settings & kill switches",
    system: "System",
  },
  badge_one: "{{count}} new",
  badge_other: "{{count}} new",
  shortcuts: {
    title: "Admin keyboard shortcuts",
    open: "Keyboard shortcuts",
    hint: "Press g, then the key, to open a tab.",
    help: "Show this list",
    back: "Back to app",
  },
  notifications: {
    title: "Staff notifications",
    open: "Notifications",
    unread_one: "{{count}} unread",
    unread_other: "{{count}} unread",
    empty: "Nothing new.",
    markAll: "Mark all read",
  },
  requests: {
    title: "Access requests",
    description: "People who asked to use Malfak. Contact them, keep notes, then approve with a plan or reject.",
    search: "Search email, username, company or phone",
    filter: { all: "All", new: "New", contacted: "Contacted", approved: "Approved", rejected: "Rejected" },
    col: { person: "Requester", company: "Company", phone: "Phone", reason: "Reason", status: "Status", received: "Received" },
    empty: "No requests here.",
    emptyHint: "New sign-ups appear here as they arrive.",
    open: "Open request from {{username}}",
    notes_one: "{{count}} note",
    notes_other: "{{count}} notes",
    status: { new: "New", contacted: "Contacted", approved: "Approved", rejected: "Rejected" },
    detail: {
      title: "@{{username}}",
      submitted: "Submitted {{when}}",
      email: "Email",
      phone: "Phone",
      company: "Company",
      heardFrom: "Heard about us",
      language: "Language",
      reason: "Why Malfak",
      consent: "Accepted the Terms and Privacy Policy {{when}}",
      none: "—",
      notes: "Notes",
      notePlaceholder: "Add an internal note (only staff see it)",
      addNote: "Add note",
      noteAdded: "Note added",
      log: "Contact log",
      logEmpty: "No activity yet.",
      decided: "Decided {{when}}",
      account: "Account",
      openOrg: "Open organization",
      rejectReason: "Reason given",
    },
    event: { submitted: "Request submitted", contacted: "Contacted", approved: "Approved", rejected: "Rejected", reopened: "Reopened" },
    by: "by {{who}}",
    channel: { phone: "Phone call", email: "Email", whatsapp: "WhatsApp", meeting: "Meeting", other: "Other" },
    actions: {
      approve: "Approve",
      reject: "Reject",
      contacted: "Mark contacted",
      call: "Call",
      email: "Email",
    },
    approve: {
      title: "Approve @{{username}}",
      description: "Creates the account (with the password they chose) and an organization they own. They can sign in right away.",
      plan: "Plan",
      orgName: "Organization name",
      note: "Note (optional)",
      confirm: "Approve and create account",
      done: "Approved: {{org}} is ready on {{plan}}",
    },
    reject: {
      title: "Reject @{{username}}",
      description: "They will see “not approved” when they try to sign in. The reason stays internal.",
      confirm: "Reject request",
      done: "Request rejected",
    },
    contact: {
      title: "Log a contact with @{{username}}",
      channel: "How",
      detail: "Summary (optional)",
      detailPlaceholder: "What did you talk about?",
      confirm: "Save",
      done: "Contact logged",
    },
  },
  calendar: {
    title: "Calendar review",
    description: "Global events that need a decision. Publishing or rejecting applies to every organization and sticks across refreshes.",
    filter: { needs_review: "Needs review", published: "Published", rejected: "Rejected", all: "All" },
    search: "Search events or country codes",
    empty: "Nothing waiting for review.",
    scope: "Scope",
    global: "Global",
    confidence: "Confidence {{value}}",
    source: "Source",
    publish: "Publish for everyone",
    reject: "Reject for everyone",
    publishTitle: "Publish “{{title}}”?",
    rejectTitle: "Reject “{{title}}”?",
    publishBody: "Every organization that follows this scope will see it (crises alert their teams).",
    rejectBody: "It disappears for every organization, also after future refreshes.",
    done: "Saved for every organization",
    status: { published: "Published", needs_review: "Needs review", rejected: "Rejected", removed: "Removed" },
  },
  system: {
    title: "System & health",
    description: "Every dependency, the live queues, versions and the latest failures.",
    versions: "Versions",
    api: "API",
    node: "Node.js",
    env: "Environment",
    schema: "Database schema",
    errors: "Recent failures",
    errorsHint: "The latest persisted failures across webhooks, operations, external actions and automation runs.",
    noErrors: "No recent failures.",
  },
};
